import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WishlistContext = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user) { setIds(new Set()); return; }
    try {
      const res = await axios.get(`${API}/my/wishlist`, { withCredentials: true });
      setIds(new Set(res.data.product_ids));
    } catch { setIds(new Set()); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (productId) => {
    if (!user) return { needsAuth: true };
    try {
      const res = await axios.post(`${API}/my/wishlist/toggle`, { product_id: productId }, { withCredentials: true });
      setIds(new Set(res.data.product_ids));
      return { ok: true, has: res.data.product_ids.includes(productId) };
    } catch { return { error: true }; }
  };

  const has = (id) => ids.has(id);

  return (
    <WishlistContext.Provider value={{ ids, has, toggle, refresh }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
